import { Controller } from "@hotwired/stimulus";

export default class ImageFallbackController extends Controller<HTMLImageElement> {
  static values = { originalUrl: String };

  declare readonly originalUrlValue: string;

  connect() {
    if (this._failedBeforeConnect()) this.useOriginal();
  }

  useOriginal() {
    if (this.element.getAttribute("src") === this.originalUrlValue) return;

    this.element.src = this.originalUrlValue;
  }

  private _failedBeforeConnect() {
    return this.element.complete && this.element.naturalWidth === 0;
  }
}
